import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
const BKJTooltipWrapperUIStateContext = createContext({
    toggleTooltip: (_e, _show) => void 0,
    showTooltip: false,
});
export const BKTooltipWrapperUIStateProvider = ({ children }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const toggleTooltip = useCallback((e, show) => {
        e.preventDefault();
        e.stopPropagation();
        setShowTooltip(show);
        return void 0;
    }, []);
    const contextValue = useMemo(() => ({
        showTooltip,
        toggleTooltip,
    }), [showTooltip, toggleTooltip]);
    return (_jsx(BKJTooltipWrapperUIStateContext.Provider, { value: contextValue, children: children }));
};
export const useBKJTooltipWrapperUIStateContext = () => useContext(BKJTooltipWrapperUIStateContext);
//# sourceMappingURL=BKJTooltipWrapper.context.js.map